<template>
    <v-toolbar fixed v-bind:class="[toolbarTransparent ? 'toolbar-transparent' : 'grey lighten-4']">
      <router-link to="/home" class="hidden-sm-and-down">
        <img v-if="logoShow" src="/src/assets/images/logo/logo_2_sm.png"  height="70px" width="auto">
      </router-link>
      <v-spacer></v-spacer>    
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat class="blue--text" v-for="link in links" :key="i" router :to="`/${link.route}`">
          {{$t(link.name)}}
        </v-btn>
        <v-menu bottom left offset-y origin="top right" transition="v-slide-y-transition">
          <v-btn flat dark slot="activator" class="blue--text">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list v-model="locale">
            <v-subheader>{{ $t("language") }}</v-subheader>
            <v-list-item v-for="lang in languages" :key="lang.id">
              <v-list-tile>
                <v-list-tile-title>
                  <input type="radio" v-bind:id="lang.id" v-bind:value="lang.id" v-model="locale">
                  <label v-bind:for="lang.id">{{lang.name}}</label>
                </v-list-tile-title>
              </v-list-tile>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-btn icon class="blue--text hidden-md-and-up" v-for="link in links" :key="i" router :to="`/${link.route}`" :title="$t(link.name)">
        <v-icon>{{link.icon}}</v-icon>
      </v-btn>
      <v-menu bottom left offset-y origin="top right" transition="v-slide-y-transition" class="hidden-md-and-up">
        <v-btn icon dark slot="activator" class="blue--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list v-model="locale">
          <v-subheader>{{ $t("language") }}</v-subheader>
          <v-list-item v-for="lang in languages" :key="lang.id">
            <v-list-tile>
              <v-list-tile-title>
                <input type="radio" v-bind:id="lang.id" v-bind:value="lang.id" v-model="locale">
                <label v-bind:for="lang.id">{{lang.name}}</label>
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
  </template>
  <script>
    export default {
      name: 'toolbar',
      data() {
        return {
          toolbarTransparent: true,
          logoShow: false,
          locale: this.$i18n.locale,
          languages: [{
              id: 'pl',
              name: 'Polski'
            },
            {
              id: 'en',
              name: 'English'
            }
          ],
          links: [{
              name: "pharmacies",
              icon: "local_pharmacy",
              route: "pharmacies"
            },
            {
              name: "wholesalers",
              icon: "domain",
              route: "wholesalers"
            },
            {
              name: "hospitals",
              icon: "local_hospital",
              route: "hospitals"
            },
            {
              name: "contact",
              icon: "phone",
              route: "contact"
            },
          ]
        };
      },
      watch: {
        locale(val) {
          this.$i18n.locale = val;
          document.cookie = "lang=" + val;
          document.documentElement.lang = val;
        }
      },
      created: function () {
        var that = this;
        window.onscroll = function () {
          if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
            that.toolbarTransparent = false;
            that.logoShow = true;
          } else {
            that.toolbarTransparent = true;
            that.logoShow = false;
          }
        }
      },
    };
  </script>
  <style>
    .toolbar-transparent {
      background-color: rgba(238, 238, 238, 0.7) !important;
    }
  </style>
  


// WEBPACK FOOTER //
// Toolbar.vue?17ada714